import * as React from 'react';

import * as styles from './ChatListSkeleton.css';
import { SkeletonItem } from './SkeletonItem';

export const ChatListSkeleton: React.FC = () => {
  return (
    <div className={styles['container']}>
      <ul className={styles['inner-container']}>
        <SkeletonItem />
        <SkeletonItem />
        <SkeletonItem />
        <SkeletonItem />
        <SkeletonItem />
        <SkeletonItem />
        <SkeletonItem />
        <SkeletonItem />
        <SkeletonItem />
      </ul>
    </div>
  );
};
